import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

// Popover Controller
//
// Initializes Bootstrap popovers on elements with proper data attributes.
// Popovers are automatically shown on hover/focus and cleaned up on disconnect.
//
// Usage Example:
// <i class="bi bi-info-circle text-muted"
//    data-controller="popover"
//    data-bs-content="Your helpful message here"
//    data-bs-trigger="hover focus"
//    data-bs-placement="right"
//    style="cursor: help;">
// </i>
//
// Available Options:
// - data-bs-content: The popover message content (required, supports HTML)
// - data-bs-trigger: When to show the popover (default: "hover click")
//                    Options: "hover", "focus", "click", or combinations like "hover focus"
// - data-bs-placement: Position relative to element (default: "top")
//                      Options: "top", "bottom", "left", "right"
//
export default class extends Controller {
  connect() {
    this.popover = new Popover(this.element, {
      trigger: this.element.dataset.bsTrigger || 'hover click',
      placement: this.element.dataset.bsPlacement || 'top',
      content: this.element.dataset.bsContent || '',
      title: this.element.dataset.bsTitle || '',
      html: true,
    })
  }

  disconnect() {
    if (this.popover) {
      this.popover.dispose()
    }
  }
}
